import { useCallback } from 'react';

/**
 * Custom hook to get the cached auth token.
 * Avoids repeated localStorage.getItem('token') calls.
 * Returns { token, remoteId, isLoggedIn, clearAuth }
 */
function useToken() {
  const token = localStorage.getItem('token');
  const remoteId = localStorage.getItem('remote_id');
  const isLoggedIn = !!token;

  const clearAuth = useCallback(() => {
    localStorage.clear();
    window.location.href = '/';
  }, []);

  const getAuthHeaders = useCallback(() => {
    if (!token) return {};
    return {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json',
    };
  }, [token]);

  return { token, remoteId, isLoggedIn, clearAuth, getAuthHeaders };
}

export default useToken;
